<template>
    <div class="singin">
        <!-- 面包屑 -->
        <breadcrumb></breadcrumb>
        <!-- 项目课题研究 多个活动 -->
       

        <div class="singin-box">
            <h5 class="clearfix">
                <span class="tit fl">已参与老师</span>
                <div class="fr right-box">
                    <el-button
                        :disabled="activeSignList.length == 0"
                        type="primary"
                        size="small"
                        @click="exportExcel('#table1', '已参与老师')"
                    >导出excel名单</el-button>
                </div>
            </h5>
            <div class="content clearfix">
                <div class="img-box fl" v-for="i in activeSignList" :key="i.id">
                    <img  :src="
              i.userLogo ? i.userLogo + '?imageView2/1/w/70/h/70' : userLogo
            " alt />
                    <br />
                    <h3>{{ i.userName }}</h3>
                </div>
            </div>
        </div>
        <div class="singin-box">
            <h5 class="clearfix">
                <span class="tit fl">未参与老师</span>
                <div class="fr right-box">
                    <el-button
                        :disabled="activeNotSignList.length == 0"
                        type="primary"
                        @click="exportExcel('#table2', '未参与老师')"
                        size="small"
                    >导出excel名单</el-button>
                </div>
            </h5>
            <div class="content clearfix">
                <div class="img-box fl" v-for="i in activeNotSignList" :key="i.id">
                    <img  :src="
              i.userLogo ? i.userLogo + '?imageView2/1/w/70/h/70' : userLogo
            " alt />
                    <br />
                    <h3>{{ i.userName }}</h3>
                </div>
            </div>
        </div>
        <el-table :data="activeSignList" style="width: 100%" id="table1" v-show="false">
            <el-table-column prop="userName" label="姓名" width="180"></el-table-column>
        </el-table>
        <el-table :data="activeNotSignList" style="width: 100%" id="table2" v-show="false">
            <el-table-column prop="userName" label="姓名" width="180"></el-table-column>
        </el-table>
    </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import Breadcrumb from "@/components/Breadcrumb.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
export default {
    components: {
        Breadcrumb,
    },
    computed: {
        modleType() {
            return this.$route.query.type;
        },
    },
    data() {
        return {
            singnInType: "",
            activeSignList: [],
            activeNotSignList: [],
            userLogo: require("@/assets/image/other/man_teacher.png"),
            //项目课题研究 子活动 列表
            activeCode: "", //子活动code
            nodeCode: "",
            actList: [],
        };
    },
    created() {
        this.actCode = this.$route.query.actCode
        this.nodeType = this.$route.query.nodeType
        this.nodeCode = this.$route.query.nodeCode
        this.selectData();
    },
    methods: {
        selectData() {
            postData("/node/getNodeTopicUserInfo",
                {
                    actCode: this.actCode,
                    nodeCode: this.nodeCode,
                    nodeType: this.nodeType
                }
            ).then(res => {               
              this.activeSignList= res.activeUserMapDTOS
              this.activeNotSignList=res.activeUserMapNotDTOS
            });

        },
        exportExcel(domId, tableName) {
            var wb = XLSX.utils.table_to_book(document.querySelector(domId));

            var wbout = XLSX.write(wb, {
                bookType: "xlsx",
                bookSST: true,
                type: "array",
            });
            try {
                FileSaver.saveAs(
                    new Blob([wbout], { type: "application/octet-stream" }),
                    tableName + ".xlsx"
                );
            } catch (e) {
                if (typeof console !== "undefined") console.log(e, wbout);
            }

            return wbout;
        },
    },
    watch: {},
};
</script>

<style lang="less" scoped>
.singin {
    // padding: 10px 20px;
    .topic-actlist {
        //   border:1px solid red;
        padding-top: 5px;
        padding-left: 20px;
        margin-top: 10px;
        background: #fff;

        ::v-deep .el-tabs__header {
            margin-bottom: 5px !important;
        }
        ::v-deep .el-tabs__item {
            font-size: 16px;
        }
    }
    .singin-box {
        margin: 15px 0px;
        background-color: #fff;
        h5 {
            border-bottom: 3px solid #f7f7f7;
            padding: 8px 20px;
            padding-bottom: 5px;
            //   border: 1px solid #000;
            .tit {
                font-size: 14px;
                font-weight: 700;
                margin-right: 20px;
                // border: 1px solid #000;
                padding: 5px;
                border-left: 4px solid @color;
            }
            .right-box {
                height: 28px;
                line-height: 28px;
                span {
                    font-size: 13px;
                    cursor: pointer;
                    padding: 5px;
                }
            }
        }
        .content {
            padding: 25px;
            background-color: #fff;
            //   border: 1px solid #000;
            height: 385px;
            overflow-y: auto;
            .img-box {
                border: 1px solid #eee;
                width: 70px;
                padding: 7.5px;
                border-radius: 5px;
                margin: 0px 15px 15px 0px;
                img {
                    width: 100%;
                    height: 70px;
                    width: 70px;
                    border-radius: 50%;
                }
                h3 {
                    margin-top: 5px;
                    font-size: 13px;
                    text-align: center;
                    width: 100%; //需要指定宽度
                    overflow: hidden; //溢出隐藏
                    text-overflow: ellipsis;
                    white-space: nowrap; //强制不换行
                }
            }
        }
    }
}
</style>
